import BaseProxy from './base.proxy';

class ConsumerProxy extends BaseProxy {
  adminGetConsumerCountInfo(id) {
    return this.get(`/admin/consumer/${id}/count-info`);
  }
  adminGetCreditHistory(id, query = {}) {
    const params = new URLSearchParams();
    Object.keys(query || {}).forEach((key) => {
      const value = query[key];
      if (Array.isArray(value)) {
        const normalized = value.filter(
          (item) => item !== undefined && item !== null && item !== ''
        );
        if (normalized.length) {
          params.append(key, normalized.join(','));
        }
        return;
      }
      if (value !== undefined && value !== null && value !== '') {
        params.append(key, value);
      }
    });
    const queryString = params.toString();
    return this.get(
      `/admin/consumer/${id}/credit/history${
        queryString ? `?${queryString}` : ''
      }`
    );
  }
  adminAdjustCredit(payload) {
    return this.post('/admin/consumer/credit/adjust', payload);
  }
  adminPayoutCredit(id) {
    return this.post(`/admin/consumer/${id}/credit/payout`);
  }
}
export default new ConsumerProxy();
